Ext.define('SA.CrosstabHeaderCell', {
    extend: 'SA.TableCell',

    statics: {
        getCls: top => `sa-crosstab-header-cell sa-crosstab-header-cell-${top ? 'top' : 'left'}`,
        getMaxLines: top => top ? 4 : 2
    },

    constructor({trimmer, top}) {
        this.callParent(arguments);

        this.trimmer = trimmer;

        this.div = document.createElement('div');
        this.div.className = this.self.getCls(top);

        this.el.classList.add('sa-crosstab-header-cell-td');
        this.el.appendChild(this.div);
    },

    getClickParams() {
        return {el: this.el, attribute: this.getCurrentId()};
    },

    getCurrentId() {
        return this.getState().id;
    },

    getDragStartParams({offset}) {
        var attribute = this.getCurrentId(),
            draggableParams = {
                offset,
                cls: 'sa-crosstab-header-cell-draggable',
                content: this.div.cloneNode(true)
            };

        return {attribute, draggableParams};
    },

    isTotal() {
        return this.getCurrentId() === 'total';
    },

    permitMouesEvent() {
        return !this.isTotal();
    },

    onStateChange(state) {
        var me = this;

        this.div.textContent = state.isTotal ? 'Total' : getAttributeLabel();
        this.div.classList.toggle('sa-crosstab-header-cell-total', state.isTotal);
        this.div.classList.toggle('sa-crosstab-header-cell-dragging', state.dragging);
        this.div.classList.toggle('sa-crosstab-header-cell-selected', state.selected);

        function getAttributeLabel() {
            var {name} = SA.data.AttributesCache.get(state.id);

            return me.trimmer.trim(name);
        }
    }
});